// User
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const USER_INIT = 'USER_INIT';
export const USER_INIT_CORRECT = 'USER_INIT_CORRECT';
export const USER_INIT_ERROR = 'USER_INIT_ERROR';

export const IS_ADMIN_USER = 'IS_ADMIN_USER';

export const CLEAR_ALL_USERS_DATA = 'CLEAR_ALL_USERS_DATA';
export const CLEAR_ALL_USERS_ERRORS = 'CLEAR_ALL_USERS_ERRORS';
export const CLEAR_USERS_ERROR = 'CLEAR_USERS_ERROR';

export const SEARCH_USER_LOADING = 'SEARCH_USER_LOADING';
export const SEARCH_USER_GET = 'SEARCH_USER_GET';
export const SEARCH_USER_ERROR = 'SEARCH_USER_ERROR';

// Organization
export const FILTERS_LOADING_TRUE = 'FILTERS_LOADING_TRUE';
export const FILTERS_LOADING_FALSE = 'FILTERS_LOADING_FALSE';

export const ORGANIZATIONS_GET = 'ORGANIZATIONS_GET';
export const ORGANIZATIONS_ERROR = 'ORGANIZATIONS_ERROR';
export const ORG_INFO_GET = 'ORG_INFO_GET';
export const ORG_INFO_ERROR = 'ORG_INFO_ERROR';

export const WORKSPACES_GET = 'WORKSPACES_GET';
export const WORKSPACES_ERROR = 'WORKSPACES_ERROR';

export const ORG_FILTERS_SET = 'ORG_FILTERS_SET';

// Areas
export const AREAS_GET = 'AREAS_GET';
export const AREAS_ERROR = 'AREAS_ERROR';

export const REGIONS_GET = 'REGIONS_GET';
export const REGIONS_ERROR = 'REGIONS_ERROR';
export const REGION_INFO_GET = 'REGION_INFO_GET';
export const REGION_INFO_ERROR = 'REGION_INFO_ERROR';

export const ZONES_GET = 'ZONES_GET';
export const ZONES_ERROR = 'ZONES_ERROR';
export const ZONE_INFO_GET = 'ZONE_INFO_GET';
export const ZONE_INFO_ERROR = 'ZONE_INFO_ERROR';

export const DEPOTS_GET = 'DEPOTS_GET';
export const DEPOTS_ERROR = 'DEPOTS_ERROR';
export const DEPOT_INFO_GET = 'DEPOT_INFO_GET';
export const DEPOT_INFO_ERROR = 'DEPOT_INFO_ERROR';

export const GROUPS_GET = 'GROUPS_GET';
export const GROUPS_ERROR = 'GROUPS_ERROR';
export const GROUP_INFO_GET = 'GROUP_INFO_GET';
export const GROUP_INFO_ERROR = 'GROUP_INFO_ERROR';

export const AREA_FILTERS_SET = 'AREA_FILTERS_SET';

// Training - Files
export const CLEAR_FILES_SINGLE_ERROR = 'CLEAR_FILES_SINGLE_ERROR';
export const CLEAR_ALL_FILES_ERRORS = 'CLEAR_ALL_FILES_ERRORS';

export const SET_FILE_ID = 'SET_FILE_ID';

export const FILE_SAVE_LOADING = 'FILE_SAVE_LOADING';
export const FILE_SAVE_ERROR = 'FILE_SAVE_ERROR';

export const ALL_FILES_LOADING = 'ALL_FILES_LOADING';
export const ALL_FILES_GET = 'ALL_FILES_GET';
export const ALL_FILES_ERROR = 'ALL_FILES_ERROR';

export const FILE_INFO_LOADING = 'FILE_INFO_LOADING';
export const FILE_INFO_GET = 'FILE_INFO_GET';
export const FILE_INFO_ERROR = 'FILE_INFO_ERROR';

export const FILE_DELETE_LOADING = 'FILE_DELETE_LOADING';

export const DOWNLOAD_FILE_LOADING = 'DOWNLOAD_FILE_LOADING';

export const FILE_LOGS_LOADING = 'FILE_LOGS_LOADING';
export const FILE_LOGS_GET = 'FILE_LOGS_GET';
export const FILE_LOGS_ERROR = 'FILE_LOGS_ERROR';

// Global
export const GLOBAL_DATA_LOADING = 'GLOBAL_DATA_LOADING';
export const GLOBAL_DATA_GET = 'GLOBAL_DATA_GET';
export const GLOBAL_DATA_ERROR = 'GLOBAL_DATA_ERROR';

// Staffs
export const CLEAR_ALL_STAFFS_DATA = 'CLEAR_ALL_STAFFS_DATA';
export const CLEAR_ALL_STAFFS_ERRORS = 'CLEAR_ALL_STAFFS_ERRORS';
export const CLEAR_STAFFS_ERROR = 'CLEAR_STAFFS_ERROR';

export const STAFF_CHECK_LOADING = 'STAFF_CHECK_LOADING';
export const STAFF_CHECK_SUCCESS = 'STAFF_CHECK_SUCCESS';
export const STAFF_CHECK_ERROR = 'STAFF_CHECK_ERROR';
